<template>
<div>

  <div class="close-drawer-section" @click="closeDrawer()">
    
  </div>

  <div v-if='selectedNote' class="note-drawer-section" v-show='$store.state.noteDrawer'>
  <div class="drawer-wrapper">

    <div class="note-drawer-title">
      Edit Note
      <div class="close-drawer" @click="closeDrawer()">
        <v-icon class="close-icon">fas fa-times</v-icon>
      </div>
    </div>

    <div class="note-drawer-container">
      <!-- section -->
      <div class="left">

        <textarea-autosize
          placeholder="Type something here..."
          ref="myTextarea"
          v-model="selectedNote.title"
          :min-height="30"
          :max-height="500"
          @blur="updateNote(selectedNote)"
        />

      </div>
      <!-- section -->
      <div class="right">
        <div class="status">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }" v-if='selectedNote.status'>
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                outlined
                style="border-color: #e3e5e6"
              >
                <v-icon v-if="selectedNote.status == 'to-do'" class='icon-progress' color='#4B84FF'>fas fa-tasks</v-icon>
                <v-icon v-if="selectedNote.status == 'In-Progress'" class='icon-progress' color='#959EFF'>far fa-clock</v-icon>
                <v-icon v-if="selectedNote.status == 'Completed'" class='icon-progress' color='#4ed319'>far fa-check-circle</v-icon>

                <span v-if="selectedNote.status == 'to-do'" class="icon-text">{{selectedNote.status}}</span>
                <span v-if="selectedNote.status == 'In-Progress'" class="icon-text">{{selectedNote.status}}</span>
                <span v-if="selectedNote.status == 'Completed'" class="icon-text">{{selectedNote.status}}</span>
                <v-icon class='icon-arrow'>fas fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="changeStatus(selectedNote, 'to-do')">
                <v-list-item-title>To-Do</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(selectedNote, 'In-Progress')">
                <v-list-item-title>In-Progress</v-list-item-title>
              </v-list-item>
              <v-list-item @click="changeStatus(selectedNote, 'Completed')">
                <v-list-item-title>Completed</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <!-- section -->
    </div>

    <!-- section -->
    <div class="note-description-section">
      <div class="description-title">
        Description
      </div>
      <div class="description-textarea">
        <div class="description-default" v-show='!descriptionEditActive' @click='descriptionEditActive=true' :class="{'description-default-empty': !selectedNote.description}">
          {{selectedNote.description}}
        </div>
        <div class="description-active" v-show='descriptionEditActive'>
          <div class="description-clicked">
            <textarea v-model='selectedNote.description'></textarea>
          </div>
          <div class="description-action-btns">
            <div v-show='selectedNote.description' class="save" @click="updateNote(selectedNote);descriptionEditActive=false">Save</div>
            <div v-show='!selectedNote.description' class="cancel" @click="descriptionEditActive=false"><v-icon class="cancel-icon">fas fa-times</v-icon></div>
          </div>
        </div>
      </div>
    </div>
    <!-- section -->

    <!-- section -->
    <div class="create-list-section">

      <div class="create-list-btn" @click="typesList=true" v-show='!typesList'>
        + Create New List
      </div>

      <div class="create-list-types" v-show='typesList'>

        <div class="select-type" v-show='selectType'>

          <div class="create-list-title">
            + Create New List
          </div>

          <div class="types-list">

            <div class="type-li" @click="type='sub-tasks';selectType=false;focusTitle()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-list-ol</v-icon>
              </div>
              <div class="type-li-title">
                Sub Tasks
              </div>
            </div>

            <div class="type-li" @click="type='bullet-list';selectType=false;focusTitle()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-list</v-icon>
              </div>
              <div class="type-li-title">
                Bullet List
              </div>
            </div>

            <div class="type-li" @click="type='video-link';selectType=false;focusTitle()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-photo-video</v-icon>
              </div>
              <div class="type-li-title">
                Video Link
              </div>
            </div>

            <div class="type-li" @click="type='reference';selectType=false;focusTitle()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-th</v-icon>
              </div>
              <div class="type-li-title">
                Reference
              </div>
            </div>

            <div class="type-li" @click="type='text-box';selectType=false;focusTitle()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-file-alt</v-icon>
              </div>
              <div class="type-li-title">
                Text Box
              </div>
            </div>

            <div class="type-li" @click="openFileStack()">
              <div class="type-li-item">
                <v-icon class='type-li-icon'>fas fa-images</v-icon>
              </div>
              <div class="type-li-title">
                Upload File
              </div>
            </div>

          </div>

        </div>

        <div class="create-list" v-show='!selectType'>

          <div class="create-list-title">
            + Create New List
          </div>

          <div class="create-list-inputs">
            <input id="listTitle" type="text" v-model='listTitle' placeholder="Title" :class="{'title-highlight': !listTitle}">
          </div>

          <div class="create-list-finish-btn" @click='storeInNoteList()' :class="{'create-list-title-active': listTitle}">
            Create
          </div>

        </div>


      </div>

    </div>
    <!-- section -->

    <!-- section -->
    <div class="lists-section" v-if='lists'>

      <div v-for="list in lists">

        <!-- Bullet List -->
        <bullet-list :list='list' :key="customDrawerListState" />

      </div>

      <div class="images-section">
        <div v-for='file in files' class="image-padding">
          <div class="image-li" @click='selectImage(file)'>
            <img :src="file.file">
          </div>
        </div>
      </div>


    </div>
    <!-- section -->

    <div class="image-viewver" v-show='imageViewerActive'>
      <v-icon class="close-viewver-icon" @click="closeViewer()">fas fa-times</v-icon>
      <img :src="imagePreview">
    </div>



  </div>
  </div>

</div>
</template>

<script>
  import Vue from 'vue'
  import api from '@/api'
  import axios from 'axios'
  import messageMixin from '@/mixin/messageMixin'
  import { mapGetters } from 'vuex'

  import BulletList from '@/components/note-drawer/lists/BulletList'
  import TextareaAutosize from 'vue-textarea-autosize'

  Vue.use(TextareaAutosize)

export default {
  name: 'noteDrawer',
  mixins: [messageMixin],
  components: {
    BulletList
  },

  data () {
    return {
      lists: null,
      typesList: false,
      selectType: true,
      type: null,
      listTitle: null,
      file: '',
      success: '',
      files: null,
      imageUrl: process.env.VUE_APP_FILE_BASE,
      imagePreview: null,
      imageViewerActive: false,
      descriptionEditActive: false
    }
  },

  computed: {
    selectedNote () {
      return this.$store.getters.selectedNote
    },

    customDrawerListState () {
      return this.$store.state.drawerListState
    }
  },

  watch: {
    selectedNote: function (val) {
      this.getLists(this.selectedNote.id)
    },
  },

  methods: {
    closeDrawer () {
      this.$store.commit('closeNoteDrawer') // close drawer
    },

    changeStatus (note, status) {
      // TODO
      note.status = status
      this.updateNote(note)
    },

    async updateNote (note, status) {
      console.log('asdasdad', note)
      const response = await api.notes.update(note, note.id)
      if (response.status < 300) {
        console.log('Note updated!!!!', response.data)
        this.$store.commit('incrementState')
      } else {
        console.log('Response error', response)
      }
    },

    async getLists (id) {
      const response = await api.notes.getInNoteList(id)
      if (response.status < 300) {
        console.log('Response!', response.data)
        this.lists = response.data.lists
        //this.lists.items.sort((a, b) => (a.order > b.order) ? 1 : -1)
      } else {
        console.log('Response error', response)
      }
    },

    async storeInNoteList () {

      if (this.listTitle == null) {
        console.log('there must be a title')
        return
      }

      this.typesList = false
      this.selectType = true

      const response = await api.notes.storeInNoteList(this.selectedNote.id, this.type, this.listTitle)
      if (response.status < 300) {
        console.log('Response!', response.data)
        this.lists.unshift(response.data.list)
        this.listTitle = ''
      } else {
        console.log('Response error', response)
      }
    },

    async getNoteFiles () {
      const response = await api.notes.getNoteFiles(this.selectedNote.id)
      if (response.status < 300) {
        console.log('Files', response.data.files)
        this.files = response.data.files
      } else {
        console.log('Response error', response)
      }
    },

    onFileChange(e){
      console.log(e.target.files[0]);
      this.file = e.target.files[0];

      this.formSubmit(e)
    },

    async formSubmit(e) {
      let self = this
      e.preventDefault();
      let currentObj = this;

      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      let formData = new FormData();
      formData.append('file', this.file);

      axios.post(process.env.VUE_APP_API_BASE + 'v2/notes/upload/file/' + this.selectedNote.id, formData, config)
      .then(function (response) {
          currentObj.success = response.data.success;
          self.getNoteFiles()
      })
      .catch(function (error) {
          currentObj.output = error;
      });
    },

    // select image for image viewer
    selectImage (file) {
      this.imagePreview = file.file
      this.imageViewerActive = true
    },

    closeViewer () {
      this.imageViewerActive = false
    },

    focusTitle () {
      Vue.nextTick()
        .then(function () {
          document.getElementById('listTitle').focus()
      })
    },

    openFileStack () {
      const options = {
          onUploadDone: file => {
            this.uploadFile(this.selectedNote.id, file.filesUploaded[0].url)
          }
      };

      const client = filestack.init(process.env.VUE_APP_FILESTACK_API)
      client.picker(options).open()
    },

    async uploadFile (id, fileUrl) {
      const response = await api.notes.uploadNoteFile(id, fileUrl)
      if (response.status < 300) {
        console.log('response filesss', response)
        this.files.push(response.data.file)
      } else {
        console.log('response error', response)
      }
    }

  },

  mounted () {
    this.getLists(this.selectedNote.id)
    this.getNoteFiles()
  }
}
</script>


<style lang="scss" scoped>

  .close-drawer-section {
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 700px);
    height: 100vh;
    background: rgba(0,0,0,0.4);
  }

  .note-drawer-section {
    position: fixed;
    top: 0;
    right: 0;
    width: 700px;
    height: 100vh;
    padding-top: 64px;
    border-left: 1px solid #eee;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 20px 0 rgba(0, 0, 0, 0.15);

    .drawer-wrapper {
      height: 95vh;
      overflow: auto;
    }

    .note-drawer-title {
      width: 100%;
      height: 56px;
      padding-left: 25px;
      padding-right: 25px;
      line-height: 58px;
      background: #f8f9fb;
      color: #9fa9bc;

      .close-drawer {
        float: right;

        .close-icon {
          font-size: 18px;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }

    .note-drawer-container {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;
      overflow: auto;

      .left {
        float: left;
        width: 70%;
        font-size: 24px;
        font-weight: 600;

        textarea {
          width: 100%;
          min-height: 35px;
          height: auto;
          outline: none;
          overflow: hidden;
          resize: none;
        }
      }

      .right {
        float: right;
        margin-top: 3px;
        .status {

          .icon-dot {

          }

          .icon-progress {
            font-size: 16px;
          }

          .icon-text {
            padding-top: 2px;
            padding-left: 5px;
            font-family: 'Roboto', sans-serif;
            font-size: 12px !important;
            font-weight: 400;
            text-transform: capitalize;
            letter-spacing: 0;
            color: #9fa9bc;
          }

          .icon-arrow {
            font-size: 16px;
            padding-left: 5px;
            color: #9fa9bc;
          }
        }
      }
    }

    .note-description-section {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;

      .description-title {
        font-size: 18px;
        color: #3A414F;
        font-weight: 600;
      }

      .description-textarea {

        textarea {
          width: 100%;
          min-height: 100px;
          padding: 10px;
          border: 1px solid #eef1f4;
          border-radius: 3px;
          background: #f6f7f9;
          outline: none;
        }
      }

      .description-default {
        width: 100%;
        min-height: 80px;
        padding: 10px;
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.25s;

        &:hover {
          background: #eef0f4;
        }
      }

      .description-default-empty {
        background: #eef0f4 !important;
      }

      .description-active {

        .description-action-btns {
          height: 40px;

          .save {
            float: left;
            width: 80px;
            height: 40px;
            margin-right: 15px;
            line-height: 40px;
            text-align: center;
            border-radius: 3px;
            background: #1976d2;
            color: #fff;
            cursor: pointer;
            transition: all 0.25s;

            &:hover {
              opacity: 0.6;
            }
          }

          .cancel-icon {
            font-size: 26px;
            line-height: 40px;
            cursor: pointer;
            transition: all 0.25s;

            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }

    .create-list-section {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;

     .create-list-btn {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
      border: 1px solid #eef0f4;
      border-radius: 3px;
      background: #f6f7f9;
      color: #656e7e;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        opacity: 0.6;
      }
    }

    .create-list-types {
      border: 1px solid #eef0f4;
      border-radius: 3px;
      background: #f6f7f9;

      .create-list-title {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        text-align: center;
        font-size: 15px;
        font-weight: 600;
        color: #656e7e;
      }

      .create-list-inputs {
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 15px;

        .title-highlight {
          border: 1px solid #1976d2;
        }

        input {
          width: 100%;
          height: 40px;
          padding-left: 10px;
          padding-right: 10px;
          border: 1px solid #eef0f4;
          border-radius: 5px;
          background: #fff;
          outline: none;
        }
      }

      .create-list-title-active {
        background: #1976d2 !important;
        color: #fff !important;
      }

      .create-list-finish-btn {
        width: 200px;
        height: 40px;
        margin: auto;
        margin-bottom: 30px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #eef0f4;
        border-radius: 5px;
        background: #eef0f4;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          background: #fff;
        }
      }

      .types-list {
        height: 280px;
        padding-left: 20px;
        overflow: auto;

        .type-li {
          float: left;
          width: 87px;
          height: 87px;
          margin-left: 12px;
          margin-right: 12px;
          margin-bottom: 50px;

          .type-li-item {
            width: 100%;
            border: 1px solid #eef0f4;
            border-radius: 3px;
            background: #fff;
            cursor: pointer;

            .type-li-icon {
              width: 100%;
              font-size: 30px;
              text-align: center;
              line-height: 86px;
              color: #9fa9bc;
            }

            &:hover {
              border: 1px solid #6d9bff;

              .type-li-icon {
                color: #6d9bff;
              }
            }
          }

          .type-li-title {
            margin-top: 5px;
            font-size: 15px;
            text-align: center;
            color: #9fa9bc;
          }

          &:hover {
            .type-li-title {
              color: #6d9bff;
            }
          }
        }
      }
    }

    }

    .lists-section {
      margin-top: 30px;
      padding-left: 50px;
      padding-right: 50px;

      .image-form {
        margin-top: 45px;
        margin-bottom: 30px;

        #submitImage {
          display: none;
        }

        .submit-image-label {
          padding: 10px 20px 10px 20px;
          border-radius: 3px;
          background: #1976d2;
          color: #fff;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.6;
          }
        }

        .custom-submit-btn {
          background: red;
        }
      }

    }

    .images-section {
      overflow: auto;

      .image-padding {
        float: left;
        width: 33.33%;
        margin-top: 15px;
        padding-left: 10px;
        padding-right: 10px;
      }

      .image-li {
        width: 100%;

        img {
          width: 100%;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    .image-viewver {
      position: fixed;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      background: rgba(0,0,0, 0.7);

      img {
        display: block;
        width: 50%;
        margin: auto;
        margin-top: 15%;
      }

      .close-viewver-icon {
        position: absolute;
        top: 85px;
        right: 22px;
        color: #fff;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.6;
        }
      }
    }

  }
</style>
